// src/features/customers/components/CustomerActionsCard.tsx
import { RefreshCw, Wallet, Receipt } from 'lucide-react';
import { GlassCard } from '../../../app/components/ui/GlassCard';

// UI placeholders only — no click logic yet. Wire these up once the
// underlying actions (renew/topup/invoices) exist.
export function CustomerActionsCard() {
  return (
    <GlassCard>
      <h2 className="text-sm font-semibold text-[var(--vania-colors-text-primary,#f5f6fa)]">
        اقدامات
      </h2>

      <div className="mt-3 flex flex-wrap gap-2">
        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-lg bg-[var(--vania-accent-violet,#7c6cff)] px-3.5 py-2 text-sm font-medium text-white hover:opacity-90"
        >
          <RefreshCw size={16} />
          تمدید سرویس
        </button>

        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-lg border border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-3.5 py-2 text-sm font-medium text-[var(--vania-colors-text-primary,#f5f6fa)] hover:bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.06))]"
        >
          <Wallet size={16} />
          شارژ کیف پول
        </button>

        <button
          type="button"
          className="inline-flex items-center gap-2 rounded-lg border border-[var(--vania-colors-border-subtle,rgba(255,255,255,0.08))] px-3.5 py-2 text-sm font-medium text-[var(--vania-colors-text-primary,#f5f6fa)] hover:bg-[var(--vania-colors-surface-secondary,rgba(255,255,255,0.06))]"
        >
          <Receipt size={16} />
          مشاهده فاکتورها
        </button>
      </div>
    </GlassCard>
  );
}
